export const GridUiDataFormatter = (getValues, setGridList) => {
  const GridValues = getValues();

  console.log("grid values are ->", GridValues);

  if (
    !GridValues?.GridDefaultValues?.every((item) => item.value.length === 0)
  ) {
    setGridList((prev) => [...prev, GridValues?.GridDefaultValues]);
  }
};
